"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightError = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var react_intl_1 = require("react-intl");
var react_1 = tslib_1.__importStar(require("react"));
var InsightErrorCore = function (_a) {
    var error = _a.error, _b = _a.ErrorComponent, ErrorComponent = _b === void 0 ? sdk_ui_1.ErrorComponent : _b, height = _a.height, intl = _a.intl, clientHeight = _a.clientHeight;
    var errorMapping = react_1.useMemo(function () { return sdk_ui_1.newErrorMapping(intl); }, [intl]);
    var errorProps = react_1.useMemo(function () { var _a; return (_a = errorMapping[error.getMessage()]) !== null && _a !== void 0 ? _a : { message: error.message }; }, [errorMapping, error]);
    return react_1.default.createElement(ErrorComponent, tslib_1.__assign({}, errorProps, { height: height, clientHeight: clientHeight }));
};
/**
 * @internal
 */
exports.InsightError = react_intl_1.injectIntl(InsightErrorCore);
//# sourceMappingURL=InsightError.js.map